module.exports = __webpack_public_path__ + "static/media/project3.6d7eeb02.jpg";